import { COMPLIANCE_STATUSES } from 'constants/status.constants';
import { SmartTable } from '@certemy/ui-components';
import { SideMenuLink } from 'components/side-menu/side-menu.component';

export interface UrlParamsParsed {
  filters?: Filters;
  page?: number;
  page_size?: number;
  activeTab?: number;
  search?: string;
  order_id?: string;
  order_type?: SmartTable.Order;
  skip_pagination?: string;
}

export interface Filters {
  status_id: number[];
  type_id?: number[];
  jobStateTypeIds?: number[];
}

export interface UrlParamsRaw {
  filters?: string;
  page?: string;
  activeTab?: string;
  search?: string;
  order_id?: string;
  order_type?: SmartTable.Order;
}

export enum JOB_STATE_TYPE {
  PRIMARY = 1,
  SECONDARY,
}

export interface JobsListSideMenuLink extends SideMenuLink {
  type?: JOB_STATE_TYPE;
  defaultQueryParams?: { [k: string]: any };
}

export const defaultFilterParams: UrlParamsParsed = {
  page: 1,
  page_size: 10,
  search: '',
  order_id: 'end_date',
  order_type: 'ASC' as SmartTable.Order,
  filters: {
    status_id: [COMPLIANCE_STATUSES.PENDING, COMPLIANCE_STATUSES.PAUSE, COMPLIANCE_STATUSES.REQUEST_CORRECTION],
    jobStateTypeIds: [JOB_STATE_TYPE.PRIMARY],
  },
};

export interface VerificationJob {
  id: number;
  step_instance_id: number;
  step_type_id: number;
  name: string;
  description: string;
  cert_name: string;
  content: any;
  response: any;
  start_date: string;
  end_date: string;
  rmd: string;
  priority: string;
  user: any;
  documents?: any;
  selected?: boolean;
  paid_by: number;
  status_id: COMPLIANCE_STATUSES;
}

export interface TableFilters {
  page: number;
  search: string;
  order: SmartTable.OrderedHeader;
}
